import './bootstrap';

const setRecaptcha =  (eventList) => {
    if (document.getElementById("tokenCaptcha").value != ""){
        Livewire.dispatch(eventList, { token: document.getElementById("tokenCaptcha").value });
    } else {
        setTimeout(() => { setRecaptcha(eventList) }, 300);
    }
}

document.addEventListener('livewire:initialized', () => {
    if (null !== document.getElementById('auth_registra')) {
        setRecaptcha('setCaptchaRegistro');
    }

    if (null !== document.getElementById('auth_recupera')) {
        setRecaptcha('setCaptchaRecupera');
    }

    if (null !== document.getElementById('auth_recupera_actualiza')) {
        setRecaptcha('setCaptchaRecuperaActualiza');
    }

    if (null !== document.getElementById('auth_home_ptt')) {
        setRecaptcha('setCaptchaPtt');
    }

    if (null !== document.getElementById('auth_home_paga')) {
        setRecaptcha('setCaptchaPagaDoc');
    }

    if (null !== document.getElementById('telefonoCelular')) {
        document.getElementById("telefonoCelular").addEventListener("input", function(event) {
            let input = event.target.value;
            let regex = /^[0-9]*$/; // Expresión regular que permite solo números

            if (!regex.test(input)) {
              event.target.value = input.slice(0, -1); // Eliminar el último caracter no numérico ingresado
            }
        });
    }

    if (null !== document.getElementById('telefonoParticular')) {
        document.getElementById("telefonoParticular").addEventListener("input", function(event) {
            let input = event.target.value;
            let regex = /^[0-9]*$/; // Expresión regular que permite solo números

            if (!regex.test(input)) {
              event.target.value = input.slice(0, -1); // Eliminar el último caracter no numérico ingresado
            }
        });
    }
})